import { ACCOUNT_COLORS, ACCOUNT_EASING } from "@/components/account/account-palette";

/**
 * Jetons de l'invitation à donner un retour.
 *
 * Les couleurs de texte et de filet sont reprises telles quelles de
 * `account-palette.ts`, qui documente pourquoi elles ne sont pas celles des
 * classes utilitaires : `--color-text-muted` en 11 px donne ≈ 2,3:1 et échoue
 * AA, et la bordure de champ du produit (0,06) donne ≈ 1,15:1 là où
 * WCAG 1.4.11 en demande 3:1 pour la frontière qui identifie un contrôle.
 * Réimporter plutôt que recopier : le jour où ces valeurs bougent, elles
 * bougent partout.
 *
 * La surface, en revanche, appartient à la famille du **shell flottant** et
 * non à celle des modales — parce qu'elle vit au-dessus du piano-roll, comme
 * lui. Le filet violet de `--color-glass-border` dit « c'est le produit qui
 * parle » ; un filet neutre l'aurait fait lire comme une pièce de chrome de
 * plus.
 */
export const PROMPT_COLORS = {
  text: ACCOUNT_COLORS.text,
  textMuted: ACCOUNT_COLORS.textMuted,
  placeholder: ACCOUNT_COLORS.placeholder,
  rule: ACCOUNT_COLORS.rule,
  accent: ACCOUNT_COLORS.accent,
  error: ACCOUNT_COLORS.error,
  ok: "var(--color-ok)",

  surface: "var(--color-glass-shell)",
  border: "var(--color-glass-border)",
} as const;

export const PROMPT_EASING = ACCOUNT_EASING;

/**
 * Le délai entre la frontière d'étape et l'apparition.
 *
 * Ce n'est pas un chiffre rond : c'est la somme de ce qui bouge déjà à cet
 * instant. Le roll défile vers la phrase suivante (~400–600 ms), le contenu du
 * shell fait son fondu croisé (200 ms), et le ressort de mise en page du shell
 * met encore 500 à 700 ms à se stabiliser. Apparaître pendant ce ballet, c'est
 * se faire ranger par l'œil avec le reste du mouvement, donc ne pas être vu.
 *
 * 1400 ms laisse tout se poser et arrive dans le silence — assez tôt pour que
 * le lien avec ce qui vient d'être réussi soit encore évident.
 */
export const PROMPT_DELAY_MS = 1400;

/** Durée d'affichage du remerciement avant effacement. */
export const PROMPT_THANKS_MS = 3200;

/** Bornes du message, imposées par `Assert\Length(min: 10, max: 1000)` côté API. */
export const MIN_MESSAGE = 10;
export const MAX_MESSAGE = 1000;
